// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dxJkOols8uhDPf8x1Pik {
  display: flex;
  margin-top: 10px;
}
.R9GI84xVHkAuHwC6BOkJ {
  padding: 10px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/admin-pages/PropertySets/Item/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,gBAAA;AAAF;AAGA;EACE,aAAA;EACA,WAAA;AADF","sourcesContent":["\n.container {\n  display: flex;\n  margin-top: 10px;\n}\n\n.content {\n  padding: 10px;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `dxJkOols8uhDPf8x1Pik`,
	"content": `R9GI84xVHkAuHwC6BOkJ`
};
export default ___CSS_LOADER_EXPORT___;
